// extracted by mini-css-extract-plugin
export default {"header":"header_header__fXehU","transparent":"header_transparent__mo0el","container":"header_container__ghpc8","active-link":"header_active-link__PqqGD","lg":"header_lg__ivQy4"};